import MapIcon from "@mui/icons-material/Map";
import { Box, Button } from "@mui/material";
import { GoogleMap } from "@react-google-maps/api";
import { Circle } from "../../theme/maps";
import { useEffect, useState } from "react";
import { getMyLocation } from "../../utils";
import { BaseModalComponent } from "../common/BaseModalComponent";
import { WidgetComponentMaps } from "../common/WidgetComponentMaps";
import { filledButton } from "../ui/styles/buttonStyles";

// Usamos llaves para asegurar que traemos la referencia correcta desde el .tsx
import { CoveragePage } from "../coverage-areas/components/principals/CoveragePage";

export const MapsAndCoveragesWidget = ({ swapyName = "mapsAndCoveragesWidget", updateUser }) => {
  const [coverageAreas, setCoverageAreas] = useState([]);
  const [map, setMap] = useState(null);

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    getMyLocation(token).then((res) => {
      setCoverageAreas(res);
    });
  }, [token]);

  const defaultPosition = { lat: 37.7749, lng: -122.4194 };
  const position = coverageAreas?.length > 0 ? { lat: coverageAreas[0]?.lat, lng: coverageAreas[0]?.lng } : defaultPosition;

  return (
    <WidgetComponentMaps
      title="Maps & Coverages"
      description="View and manage your business coverage areas directly on the map to keep your service zones up to date."
      icon={<MapIcon />}
      sxProp={{
        // height: { lg: "80%" },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          position: "relative",
          width: "100%",
          height: "80%",
          borderRadius: "12px",
          overflow: "hidden",
          mb: 2,
          minHeight: { xs: "200px", sm: "250px", md: "350px", lg: "50vh" },
          maxHeight: { xs: "40vh", md: "60vh", lg: "60vh" },
        }}
      >
        <GoogleMap
          mapContainerStyle={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          options={{
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
          center={position}
          zoom={10}
          onLoad={(mapInstance) => setMap(mapInstance)}
        >
          {coverageAreas?.map((area, index) => (
            <Circle
              key={index}
              center={{ lat: area.lat, lng: area.lng }}
              radius={area.radius}
              options={{
                strokeColor: "#FB8E00",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: "#FB8E00",
                fillOpacity: 0.25,
              }}
            />
          ))}
        </GoogleMap>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          bgcolor: "transparent",
          justifyContent: "center",
          alignItems: "center",
          py: 1,
        }}
      >
        <BaseModalComponent
          modalKey="Organization-CoverageAreas-Business"
          modalLabel="Manage Coverage Areas"
          elementTrigger={<Button sx={filledButton}>Manage My Areas</Button>}
          sx={{
            width: { xs: "90%", sm: "80%", md: "100%", lg: "1600px" },
            height: { xs: "95%", sm: "90%", md: "100%", lg: "100%" },
          }}
        >
          {/* Aquí el componente ya no debería ser undefined */}
          <CoveragePage />
        </BaseModalComponent>
      </Box>
    </WidgetComponentMaps>
  );
};
